// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page_Page__1URxe","PageTitle":"Page_PageTitle__24ugA","TitleUnderline":"Page_TitleUnderline__-jkt_"};